import styled from 'styled-components'

export const BaseConfetti = styled.svg.attrs({
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
})`
  overflow: visible;
  position: absolute;
  pointer-events: none;
`
